export const MR_EXCEL_SHORTCUTS = [
  {
    "category": "File",
    "title": "Create new workbook",
    "windows": "Ctrl N",
    "mac": "⌘N",
    "slug": "create-new-workbook",
    "level": "Most used"
  },
  {
    "category": "File",
    "title": "Open workbook",
    "windows": "Ctrl O",
    "mac": "⌘O",
    "slug": "open-workbook",
    "level": "Most used"
  },
  {
    "category": "File",
    "title": "Save workbook",
    "windows": "Ctrl S",
    "mac": "⌘S",
    "slug": "save-workbook",
    "level": "Most used"
  },
  {
    "category": "File",
    "title": "Save as",
    "windows": "F12",
    "mac": "⌘⇧S",
    "slug": "save-as",
    "level": "Useful"
  },
  {
    "category": "File",
    "title": "Print file",
    "windows": "Ctrl P",
    "mac": "⌘P",
    "slug": "print-file",
    "level": "Most used"
  },
  {
    "category": "File",
    "title": "Open print preview window",
    "windows": "Ctrl F2",
    "mac": "",
    "slug": "open-print-preview-window",
    "level": "Useful"
  },
  {
    "category": "File",
    "title": "Close current workbook",
    "windows": "Ctrl W",
    "mac": "⌘W",
    "slug": "close-current-workbook",
    "level": "Useful"
  },
  {
    "category": "File",
    "title": "Close Excel",
    "windows": "Alt F4",
    "mac": "⌘Q",
    "slug": "close-excel",
    "level": "Useful"
  },
  {
    "category": "Ribbon",
    "title": "Expand or collapse ribbon",
    "windows": "Ctrl F1",
    "mac": "⌘⌥R",
    "slug": "expand-or-collapse-ribbon",
    "level": "Useful"
  },
  {
    "category": "Ribbon",
    "title": "Activate access keys",
    "windows": "Alt",
    "mac": "",
    "slug": "activate-access-keys",
    "level": "Useful"
  },
  {
    "category": "Ribbon",
    "title": "Move to next ribbon control",
    "windows": "Tab",
    "mac": "Tab",
    "slug": "move-to-next-ribbon-control",
    "level": "Useful"
  },
  {
    "category": "Ribbon",
    "title": "Activate or open selected control",
    "windows": "Space",
    "mac": "Space",
    "slug": "activate-or-open-selected-control",
    "level": "Useful"
  },
  {
    "category": "Ribbon",
    "title": "Confirm control change",
    "windows": "Enter",
    "mac": "Return",
    "slug": "confirm-control-change",
    "level": "Useful"
  },
  {
    "category": "Ribbon",
    "title": "Get help on selected control",
    "windows": "F1",
    "mac": "",
    "slug": "get-help-on-selected-control",
    "level": "Useful"
  },
  {
    "category": "General",
    "title": "Open options",
    "windows": "Alt F T",
    "mac": "⌘,",
    "slug": "open-options",
    "level": "Useful"
  },
  {
    "category": "General",
    "title": "Open help",
    "windows": "F1",
    "mac": "⌘/",
    "slug": "open-help",
    "level": "Useful"
  },
  {
    "category": "General",
    "title": "Undo last action",
    "windows": "Ctrl Z",
    "mac": "⌘Z",
    "slug": "undo-last-action",
    "level": "Most used"
  },
  {
    "category": "General",
    "title": "Redo last action",
    "windows": "Ctrl Y",
    "mac": "⌘Y",
    "slug": "redo-last-action",
    "level": "Most used"
  },
  {
    "category": "General",
    "title": "Copy selected cells",
    "windows": "Ctrl C",
    "mac": "⌘C",
    "slug": "copy-selected-cells",
    "level": "Most used"
  },
  {
    "category": "General",
    "title": "Repeat last action",
    "windows": "F4",
    "mac": "⌘Y",
    "slug": "repeat-last-action",
    "level": "Useful"
  },
  {
    "category": "General",
    "title": "Cut selected cells",
    "windows": "Ctrl X",
    "mac": "⌘X",
    "slug": "cut-selected-cells",
    "level": "Most used"
  },
  {
    "category": "General",
    "title": "Paste values",
    "windows": "Ctrl Shift V",
    "mac": "⌘⇧V",
    "slug": "paste-values",
    "level": "Most used"
  },
  {
    "category": "General",
    "title": "Paste content from clipboard",
    "windows": "Ctrl V",
    "mac": "⌘V",
    "slug": "paste-content-from-clipboard",
    "level": "Most used"
  },
  {
    "category": "General",
    "title": "Display the Paste Special dialog box",
    "windows": "Ctrl Alt V",
    "mac": "⌘⌃V",
    "slug": "display-the-paste-special-dialog-box",
    "level": "Useful"
  },
  {
    "category": "General",
    "title": "Display find and replace",
    "windows": "Ctrl F",
    "mac": "⌘F",
    "slug": "display-find-and-replace",
    "level": "Most used"
  },
  {
    "category": "General",
    "title": "Display find and replace, replace selected",
    "windows": "Ctrl H",
    "mac": "⌃H",
    "slug": "display-find-and-replace-replace-selected",
    "level": "Useful"
  },
  {
    "category": "General",
    "title": "Find previous match",
    "windows": "Ctrl Shift F4",
    "mac": "⌘⇧G",
    "slug": "find-previous-match",
    "level": "Useful"
  },
  {
    "category": "General",
    "title": "Find next match",
    "windows": "Shift F4",
    "mac": "⌘G",
    "slug": "find-next-match",
    "level": "Useful"
  },
  {
    "category": "General",
    "title": "Create embedded chart",
    "windows": "Alt F1",
    "mac": "Fn⌥F1",
    "slug": "create-embedded-chart",
    "level": "Useful"
  },
  {
    "category": "General",
    "title": "Create chart in new worksheet",
    "windows": "F11",
    "mac": "Fn F11",
    "slug": "create-chart-in-new-worksheet",
    "level": "Useful"
  },
  {
    "category": "Tables and Filters",
    "title": "Insert table",
    "windows": "Ctrl T",
    "mac": "⌘T",
    "slug": "insert-table",
    "level": "Most used"
  },
  {
    "category": "Tables and Filters",
    "title": "Toggle Autofilter",
    "windows": "Ctrl Shift L",
    "mac": "⌘⇧F",
    "slug": "toggle-autofilter",
    "level": "Most used"
  },
  {
    "category": "Tables and Filters",
    "title": "Activate filter",
    "windows": "Alt↓",
    "mac": "⌥↓",
    "slug": "activate-filter",
    "level": "Useful"
  },
  {
    "category": "Tables and Filters",
    "title": "Select table row",
    "windows": "Shift Space",
    "mac": "⇧Space",
    "slug": "select-table-row",
    "level": "Useful"
  },
  {
    "category": "Tables and Filters",
    "title": "Select table column",
    "windows": "Ctrl Space",
    "mac": "⌃Space",
    "slug": "select-table-column",
    "level": "Useful"
  },
  {
    "category": "Tables and Filters",
    "title": "Select table",
    "windows": "Ctrl A",
    "mac": "⌘A",
    "slug": "select-table",
    "level": "Useful"
  },
  {
    "category": "Tables and Filters",
    "title": "Clear slicer filter",
    "windows": "Alt C",
    "mac": "⌥C",
    "slug": "clear-slicer-filter",
    "level": "Useful"
  },
  {
    "category": "Tables and Filters",
    "title": "Toggle table total row",
    "windows": "Ctrl Shift T",
    "mac": "⌃⇧T",
    "slug": "toggle-table-total-row",
    "level": "Useful"
  },
  {
    "category": "Drag and Drop",
    "title": "Drag and cut",
    "windows": "drag",
    "mac": "drag",
    "slug": "drag-and-cut",
    "level": "Useful"
  },
  {
    "category": "Drag and Drop",
    "title": "Drag and copy",
    "windows": "Ctrl drag",
    "mac": "⌥drag",
    "slug": "drag-and-copy",
    "level": "Useful"
  },
  {
    "category": "Drag and Drop",
    "title": "Drag and insert",
    "windows": "Shift drag",
    "mac": "⇧drag",
    "slug": "drag-and-insert",
    "level": "Useful"
  },
  {
    "category": "Drag and Drop",
    "title": "Drag and insert copy",
    "windows": "Ctrl Shift drag",
    "mac": "⌥⇧drag",
    "slug": "drag-and-insert-copy",
    "level": "Useful"
  },
  {
    "category": "Drag and Drop",
    "title": "Drag to worksheet",
    "windows": "Alt drag",
    "mac": "⌘drag",
    "slug": "drag-to-worksheet",
    "level": "Useful"
  },
  {
    "category": "Drag and Drop",
    "title": "Drag to duplicate worksheet",
    "windows": "Ctrl drag",
    "mac": "⌥drag",
    "slug": "drag-to-duplicate-worksheet",
    "level": "Useful"
  },
  {
    "category": "Navigation",
    "title": "Move one cell right",
    "windows": "→",
    "mac": "→",
    "slug": "move-one-cell-right",
    "level": "Useful"
  },
  {
    "category": "Navigation",
    "title": "Move one cell left",
    "windows": "←",
    "mac": "←",
    "slug": "move-one-cell-left",
    "level": "Useful"
  },
  {
    "category": "Navigation",
    "title": "Move one cell up",
    "windows": "↑",
    "mac": "↑",
    "slug": "move-one-cell-up",
    "level": "Useful"
  },
  {
    "category": "Navigation",
    "title": "Move one cell down",
    "windows": "↓",
    "mac": "↓",
    "slug": "move-one-cell-down",
    "level": "Useful"
  },
  {
    "category": "Navigation",
    "title": "Move one screen right",
    "windows": "Alt PgDn",
    "mac": "Fn⌥↓",
    "slug": "move-one-screen-right",
    "level": "Useful"
  },
  {
    "category": "Navigation",
    "title": "Move one screen left",
    "windows": "Alt PgUp",
    "mac": "Fn⌥↑",
    "slug": "move-one-screen-left",
    "level": "Useful"
  },
  {
    "category": "Navigation",
    "title": "Move one screen up",
    "windows": "PgUp",
    "mac": "Fn↑",
    "slug": "move-one-screen-up",
    "level": "Useful"
  },
  {
    "category": "Navigation",
    "title": "Move one screen down",
    "windows": "PgDn",
    "mac": "Fn↓",
    "slug": "move-one-screen-down",
    "level": "Useful"
  },
  {
    "category": "Navigation",
    "title": "Move to right edge of data region",
    "windows": "Ctrl→",
    "mac": "⌘→",
    "slug": "move-to-right-edge-of-data-region",
    "level": "Most used"
  },
  {
    "category": "Navigation",
    "title": "Move to left edge of data region",
    "windows": "Ctrl←",
    "mac": "⌘←",
    "slug": "move-to-left-edge-of-data-region",
    "level": "Most used"
  },
  {
    "category": "Navigation",
    "title": "Move to top edge of data region",
    "windows": "Ctrl↑",
    "mac": "⌘↑",
    "slug": "move-to-top-edge-of-data-region",
    "level": "Most used"
  },
  {
    "category": "Navigation",
    "title": "Move to bottom edge of data region",
    "windows": "Ctrl↓",
    "mac": "⌘↓",
    "slug": "move-to-bottom-edge-of-data-region",
    "level": "Most used"
  },
  {
    "category": "Navigation",
    "title": "Move to beginning of row",
    "windows": "Home",
    "mac": "Fn←",
    "slug": "move-to-beginning-of-row",
    "level": "Useful"
  },
  {
    "category": "Navigation",
    "title": "Move to last cell in worksheet",
    "windows": "Ctrl End",
    "mac": "Fn⌃→",
    "slug": "move-to-last-cell-in-worksheet",
    "level": "Useful"
  },
  {
    "category": "Navigation",
    "title": "Move to first cell in worksheet",
    "windows": "Ctrl Home",
    "mac": "Fn⌃←",
    "slug": "move-to-first-cell-in-worksheet",
    "level": "Useful"
  },
  {
    "category": "Navigation",
    "title": "Turn End mode on",
    "windows": "End",
    "mac": "Fn→",
    "slug": "turn-end-mode-on",
    "level": "Useful"
  },
  {
    "category": "Navigation",
    "title": "Go back to hyperlink",
    "windows": "Ctrl G Enter",
    "mac": "⌃G Return",
    "slug": "go-back-to-hyperlink",
    "level": "Useful"
  },
  {
    "category": "Selection",
    "title": "Select entire row",
    "windows": "Shift Space",
    "mac": "⇧Space",
    "slug": "select-entire-row",
    "level": "Most used"
  },
  {
    "category": "Selection",
    "title": "Select entire column",
    "windows": "Ctrl Space",
    "mac": "⌃Space",
    "slug": "select-entire-column",
    "level": "Most used"
  },
  {
    "category": "Selection",
    "title": "Select entire worksheet",
    "windows": "Ctrl A",
    "mac": "⌘A",
    "slug": "select-entire-worksheet",
    "level": "Most used"
  },
  {
    "category": "Selection",
    "title": "Add adjacent cells to selection",
    "windows": "Shift Click",
    "mac": "⇧Click",
    "slug": "add-adjacent-cells-to-selection",
    "level": "Useful"
  },
  {
    "category": "Selection",
    "title": "Add non-adjacent cells to selection",
    "windows": "Ctrl Click",
    "mac": "⌘Click",
    "slug": "add-non-adjacent-cells-to-selection",
    "level": "Useful"
  },
  {
    "category": "Selection",
    "title": "Same selection in next column",
    "windows": "",
    "mac": "⌥Tab",
    "slug": "same-selection-in-next-column",
    "level": "Useful"
  },
  {
    "category": "Selection",
    "title": "Same selection in previous column",
    "windows": "",
    "mac": "⌥⇧Tab",
    "slug": "same-selection-in-previous-column",
    "level": "Useful"
  },
  {
    "category": "Selection",
    "title": "Move right between non-adjacent selections",
    "windows": "Ctrl Alt→",
    "mac": "⌃⌥→",
    "slug": "move-right-between-non-adjacent-selections",
    "level": "Useful"
  },
  {
    "category": "Selection",
    "title": "Move left between non-adjacent selections",
    "windows": "Ctrl Alt←",
    "mac": "⌃⌥←",
    "slug": "move-left-between-non-adjacent-selections",
    "level": "Useful"
  },
  {
    "category": "Selection",
    "title": "Toggle add to selection mode",
    "windows": "Shift F8",
    "mac": "Fn⇧F8",
    "slug": "toggle-add-to-selection-mode",
    "level": "Useful"
  },
  {
    "category": "Selection",
    "title": "Cancel selection",
    "windows": "Esc",
    "mac": "Esc",
    "slug": "cancel-selection",
    "level": "Useful"
  },
  {
    "category": "Active Cell",
    "title": "Select active cell only",
    "windows": "Shift Backspace",
    "mac": "⇧Delete",
    "slug": "select-active-cell-only",
    "level": "Useful"
  },
  {
    "category": "Active Cell",
    "title": "Show the active cell on worksheet",
    "windows": "Ctrl Backspace",
    "mac": "⌃Delete",
    "slug": "show-the-active-cell-on-worksheet",
    "level": "Useful"
  },
  {
    "category": "Active Cell",
    "title": "Move active cell clockwise in selection",
    "windows": "Ctrl.",
    "mac": "⌃.",
    "slug": "move-active-cell-clockwise-in-selection",
    "level": "Useful"
  },
  {
    "category": "Active Cell",
    "title": "Move active cell down in selection",
    "windows": "Enter",
    "mac": "Return",
    "slug": "move-active-cell-down-in-selection",
    "level": "Useful"
  },
  {
    "category": "Active Cell",
    "title": "Move active cell up in selection",
    "windows": "Shift Enter",
    "mac": "⇧Return",
    "slug": "move-active-cell-up-in-selection",
    "level": "Useful"
  },
  {
    "category": "Active Cell",
    "title": "Move active cell right in a selection",
    "windows": "Tab",
    "mac": "Tab",
    "slug": "move-active-cell-right-in-a-selection",
    "level": "Useful"
  },
  {
    "category": "Active Cell",
    "title": "Move active cell left in a selection",
    "windows": "Shift Tab",
    "mac": "⇧Tab",
    "slug": "move-active-cell-left-in-a-selection",
    "level": "Useful"
  },
  {
    "category": "Extend Selection",
    "title": "Extend selection by one cell right",
    "windows": "Shift→",
    "mac": "⇧→",
    "slug": "extend-selection-by-one-cell-right",
    "level": "Useful"
  },
  {
    "category": "Extend Selection",
    "title": "Extend selection by one cell left",
    "windows": "Shift←",
    "mac": "⇧←",
    "slug": "extend-selection-by-one-cell-left",
    "level": "Useful"
  },
  {
    "category": "Extend Selection",
    "title": "Extend selection by one cell up",
    "windows": "Shift↑",
    "mac": "⇧↑",
    "slug": "extend-selection-by-one-cell-up",
    "level": "Useful"
  },
  {
    "category": "Extend Selection",
    "title": "Extend selection by one cell down",
    "windows": "Shift↓",
    "mac": "⇧↓",
    "slug": "extend-selection-by-one-cell-down",
    "level": "Useful"
  },
  {
    "category": "Extend Selection",
    "title": "Extend the selection to the last cell right",
    "windows": "Ctrl Shift→",
    "mac": "⌘⇧→",
    "slug": "extend-the-selection-to-the-last-cell-right",
    "level": "Useful"
  },
  {
    "category": "Extend Selection",
    "title": "Extend the selection to the last cell left",
    "windows": "Ctrl Shift←",
    "mac": "⌘⇧←",
    "slug": "extend-the-selection-to-the-last-cell-left",
    "level": "Useful"
  },
  {
    "category": "Extend Selection",
    "title": "Extend the selection to the last cell up",
    "windows": "Ctrl Shift↑",
    "mac": "⌘⇧↑",
    "slug": "extend-the-selection-to-the-last-cell-up",
    "level": "Useful"
  },
  {
    "category": "Extend Selection",
    "title": "Extend the selection to the last cell down",
    "windows": "Ctrl Shift↓",
    "mac": "⌘⇧↓",
    "slug": "extend-the-selection-to-the-last-cell-down",
    "level": "Useful"
  },
  {
    "category": "Extend Selection",
    "title": "Extend selection up one screen",
    "windows": "Shift PgUp",
    "mac": "Fn⇧↑",
    "slug": "extend-selection-up-one-screen",
    "level": "Useful"
  },
  {
    "category": "Extend Selection",
    "title": "Extend selection down one screen",
    "windows": "Shift PgDn",
    "mac": "Fn⇧↓",
    "slug": "extend-selection-down-one-screen",
    "level": "Useful"
  },
  {
    "category": "Extend Selection",
    "title": "Extend selection right one screen",
    "windows": "Alt Shift PgDn",
    "mac": "Fn⇧⌥↓",
    "slug": "extend-selection-right-one-screen",
    "level": "Useful"
  },
  {
    "category": "Extend Selection",
    "title": "Extend selection left one screen",
    "windows": "Alt Shift PgUp",
    "mac": "Fn⇧⌥↑",
    "slug": "extend-selection-left-one-screen",
    "level": "Useful"
  },
  {
    "category": "Extend Selection",
    "title": "Extend selection to start of row",
    "windows": "Shift Home",
    "mac": "Fn⇧←",
    "slug": "extend-selection-to-start-of-row",
    "level": "Useful"
  },
  {
    "category": "Extend Selection",
    "title": "Extend selection to first cell in worksheet",
    "windows": "Ctrl Shift Home",
    "mac": "Fn⌃⇧←",
    "slug": "extend-selection-to-first-cell-in-worksheet",
    "level": "Useful"
  },
  {
    "category": "Extend Selection",
    "title": "Extend selection to last cell in worksheet",
    "windows": "Ctrl Shift End",
    "mac": "Fn⌃⇧→",
    "slug": "extend-selection-to-last-cell-in-worksheet",
    "level": "Useful"
  },
  {
    "category": "Extend Selection",
    "title": "Toggle extend selection mode",
    "windows": "F8",
    "mac": "Fn F8",
    "slug": "toggle-extend-selection-mode",
    "level": "Useful"
  },
  {
    "category": "Select Special",
    "title": "Display 'Go To' dialog box",
    "windows": "Ctrl G",
    "mac": "⌃G",
    "slug": "display-go-to-dialog-box",
    "level": "Specialized"
  },
  {
    "category": "Select Special",
    "title": "Select cells with comments",
    "windows": "Ctrl Shift O",
    "mac": "Fn⌃⇧O",
    "slug": "select-cells-with-comments",
    "level": "Specialized"
  },
  {
    "category": "Select Special",
    "title": "Select current region around active cell",
    "windows": "Ctrl Shift*",
    "mac": "⌃⇧Space",
    "slug": "select-current-region-around-active-cell",
    "level": "Specialized"
  },
  {
    "category": "Select Special",
    "title": "Select current region",
    "windows": "Ctrl A",
    "mac": "⌘A",
    "slug": "select-current-region",
    "level": "Specialized"
  },
  {
    "category": "Select Special",
    "title": "Select current array",
    "windows": "Ctrl/",
    "mac": "⌃/",
    "slug": "select-current-array",
    "level": "Specialized"
  },
  {
    "category": "Select Special",
    "title": "Select row differences",
    "windows": "Ctrl\\",
    "mac": "⌃\\",
    "slug": "select-row-differences",
    "level": "Specialized"
  },
  {
    "category": "Select Special",
    "title": "Select column differences",
    "windows": "Ctrl Shift|",
    "mac": "⌃⇧|",
    "slug": "select-column-differences",
    "level": "Specialized"
  },
  {
    "category": "Select Special",
    "title": "Select direct precedents",
    "windows": "Ctrl[",
    "mac": "⌃[",
    "slug": "select-direct-precedents",
    "level": "Specialized"
  },
  {
    "category": "Select Special",
    "title": "Select all precedents",
    "windows": "Ctrl Shift{",
    "mac": "⌃⇧{",
    "slug": "select-all-precedents",
    "level": "Specialized"
  },
  {
    "category": "Select Special",
    "title": "Select direct dependents",
    "windows": "Ctrl]",
    "mac": "⌃]",
    "slug": "select-direct-dependents",
    "level": "Specialized"
  },
  {
    "category": "Select Special",
    "title": "Select all dependents",
    "windows": "Ctrl Shift}",
    "mac": "⌃⇧}",
    "slug": "select-all-dependents",
    "level": "Specialized"
  },
  {
    "category": "Select Special",
    "title": "Select visible cells only",
    "windows": "Alt;",
    "mac": "⌘⇧Z",
    "slug": "select-visible-cells-only",
    "level": "Specialized"
  },
  {
    "category": "Cell Edit Mode",
    "title": "Edit the active cell",
    "windows": "F2",
    "mac": "⌃U",
    "slug": "edit-the-active-cell",
    "level": "Most used"
  },
  {
    "category": "Cell Edit Mode",
    "title": "Cancel entry",
    "windows": "Esc",
    "mac": "Esc",
    "slug": "cancel-entry",
    "level": "Useful"
  },
  {
    "category": "Cell Edit Mode",
    "title": "Select one character right",
    "windows": "Shift→",
    "mac": "⇧→",
    "slug": "select-one-character-right",
    "level": "Useful"
  },
  {
    "category": "Cell Edit Mode",
    "title": "Select one character left",
    "windows": "Shift←",
    "mac": "⇧←",
    "slug": "select-one-character-left",
    "level": "Useful"
  },
  {
    "category": "Cell Edit Mode",
    "title": "Move one word right",
    "windows": "Ctrl→",
    "mac": "⌃→",
    "slug": "move-one-word-right",
    "level": "Useful"
  },
  {
    "category": "Cell Edit Mode",
    "title": "Move one word left",
    "windows": "Ctrl←",
    "mac": "⌃←",
    "slug": "move-one-word-left",
    "level": "Useful"
  },
  {
    "category": "Cell Edit Mode",
    "title": "Select one word right",
    "windows": "Ctrl Shift→",
    "mac": "⌃⇧→",
    "slug": "select-one-word-right",
    "level": "Useful"
  },
  {
    "category": "Cell Edit Mode",
    "title": "Select one word left",
    "windows": "Ctrl Shift←",
    "mac": "⌃⇧←",
    "slug": "select-one-word-left",
    "level": "Useful"
  },
  {
    "category": "Cell Edit Mode",
    "title": "Select to beginning of cell",
    "windows": "Shift Home",
    "mac": "Fn⇧←",
    "slug": "select-to-beginning-of-cell",
    "level": "Useful"
  },
  {
    "category": "Cell Edit Mode",
    "title": "Select to end of cell",
    "windows": "Shift End",
    "mac": "Fn⇧→",
    "slug": "select-to-end-of-cell",
    "level": "Useful"
  },
  {
    "category": "Cell Edit Mode",
    "title": "Delete to end of line",
    "windows": "Ctrl Delete",
    "mac": "Fn⌃Delete",
    "slug": "delete-to-end-of-line",
    "level": "Useful"
  },
  {
    "category": "Cell Edit Mode",
    "title": "Delete character to the left of cursor",
    "windows": "Backspace",
    "mac": "Delete",
    "slug": "delete-character-to-the-left-of-cursor",
    "level": "Useful"
  },
  {
    "category": "Cell Edit Mode",
    "title": "Delete character to the right of cursor",
    "windows": "Delete",
    "mac": "Fn Delete",
    "slug": "delete-character-to-the-right-of-cursor",
    "level": "Useful"
  },
  {
    "category": "Cell Edit Mode",
    "title": "Insert line break in cell",
    "windows": "Alt Enter",
    "mac": "⌃⌥Return",
    "slug": "insert-line-break-in-cell",
    "level": "Most used"
  },
  {
    "category": "Entering Data",
    "title": "Enter and move down",
    "windows": "Enter",
    "mac": "Return",
    "slug": "enter-and-move-down",
    "level": "Useful"
  },
  {
    "category": "Entering Data",
    "title": "Enter and move up",
    "windows": "Shift Enter",
    "mac": "⇧Return",
    "slug": "enter-and-move-up",
    "level": "Useful"
  },
  {
    "category": "Entering Data",
    "title": "Enter and move right",
    "windows": "Tab",
    "mac": "Tab",
    "slug": "enter-and-move-right",
    "level": "Useful"
  },
  {
    "category": "Entering Data",
    "title": "Enter and move left",
    "windows": "Shift Tab",
    "mac": "⇧Tab",
    "slug": "enter-and-move-left",
    "level": "Useful"
  },
  {
    "category": "Entering Data",
    "title": "Complete entry and stay in same cell",
    "windows": "Ctrl Enter",
    "mac": "⌃Return",
    "slug": "complete-entry-and-stay-in-same-cell",
    "level": "Useful"
  },
  {
    "category": "Entering Data",
    "title": "Enter same data in multiple cells",
    "windows": "Ctrl Enter",
    "mac": "⌃Return",
    "slug": "enter-same-data-in-multiple-cells",
    "level": "Useful"
  },
  {
    "category": "Entering Data",
    "title": "Insert current date",
    "windows": "Ctrl;",
    "mac": "⌃;",
    "slug": "insert-current-date",
    "level": "Most used"
  },
  {
    "category": "Entering Data",
    "title": "Insert current time",
    "windows": "Ctrl Shift:",
    "mac": "⌘;",
    "slug": "insert-current-time",
    "level": "Most used"
  },
  {
    "category": "Entering Data",
    "title": "Fill down from cell above",
    "windows": "Ctrl D",
    "mac": "⌘D",
    "slug": "fill-down-from-cell-above",
    "level": "Most used"
  },
  {
    "category": "Entering Data",
    "title": "Fill right from cell left",
    "windows": "Ctrl R",
    "mac": "⌘R",
    "slug": "fill-right-from-cell-left",
    "level": "Most used"
  },
  {
    "category": "Entering Data",
    "title": "Copy formula from cell above",
    "windows": "Ctrl'",
    "mac": "⌘'",
    "slug": "copy-formula-from-cell-above",
    "level": "Useful"
  },
  {
    "category": "Entering Data",
    "title": "Copy value from cell above",
    "windows": "Ctrl Shift\"",
    "mac": "⌃⇧\"",
    "slug": "copy-value-from-cell-above",
    "level": "Useful"
  },
  {
    "category": "Entering Data",
    "title": "Add hyperlink",
    "windows": "Ctrl K",
    "mac": "⌘K",
    "slug": "add-hyperlink",
    "level": "Useful"
  },
  {
    "category": "Entering Data",
    "title": "Display AutoComplete list",
    "windows": "Alt↓",
    "mac": "⌥↓",
    "slug": "display-autocomplete-list",
    "level": "Useful"
  },
  {
    "category": "Entering Data",
    "title": "Flash fill",
    "windows": "Ctrl E",
    "mac": "⌃E",
    "slug": "flash-fill",
    "level": "Most used"
  },
  {
    "category": "Formatting",
    "title": "Format (almost) anything",
    "windows": "Ctrl 1",
    "mac": "⌘1",
    "slug": "format-almost-anything",
    "level": "Most used"
  },
  {
    "category": "Formatting",
    "title": "Display Format Cells with Font tab selected",
    "windows": "Ctrl Shift F",
    "mac": "⌃⇧F",
    "slug": "display-format-cells-with-font-tab-selected",
    "level": "Useful"
  },
  {
    "category": "Formatting",
    "title": "Toggle bold formatting",
    "windows": "Ctrl B",
    "mac": "⌘B",
    "slug": "toggle-bold-formatting",
    "level": "Most used"
  },
  {
    "category": "Formatting",
    "title": "Toggle italic formatting",
    "windows": "Ctrl I",
    "mac": "⌘I",
    "slug": "toggle-italic-formatting",
    "level": "Most used"
  },
  {
    "category": "Formatting",
    "title": "Toggle underline formatting",
    "windows": "Ctrl U",
    "mac": "⌘U",
    "slug": "toggle-underline-formatting",
    "level": "Most used"
  },
  {
    "category": "Formatting",
    "title": "Toggle strikethrough formatting",
    "windows": "Ctrl 5",
    "mac": "⌘⇧X",
    "slug": "toggle-strikethrough-formatting",
    "level": "Useful"
  },
  {
    "category": "Formatting",
    "title": "Align center",
    "windows": "Alt H A C",
    "mac": "⌘E",
    "slug": "align-center",
    "level": "Useful"
  },
  {
    "category": "Formatting",
    "title": "Align left",
    "windows": "Alt H A L",
    "mac": "⌘L",
    "slug": "align-left",
    "level": "Useful"
  },
  {
    "category": "Formatting",
    "title": "Align right",
    "windows": "Alt H A R",
    "mac": "⌘R",
    "slug": "align-right",
    "level": "Useful"
  },
  {
    "category": "Formatting",
    "title": "Indent",
    "windows": "Alt H 6",
    "mac": "⌃⌥Tab",
    "slug": "indent",
    "level": "Useful"
  },
  {
    "category": "Formatting",
    "title": "Remove indent",
    "windows": "Alt H 5",
    "mac": "⌃⌥⇧Tab",
    "slug": "remove-indent",
    "level": "Useful"
  },
  {
    "category": "Formatting",
    "title": "Increase font size one step",
    "windows": "Alt H FG",
    "mac": "⌘⇧>",
    "slug": "increase-font-size-one-step",
    "level": "Useful"
  },
  {
    "category": "Formatting",
    "title": "Decrease font size one step",
    "windows": "Alt H FK",
    "mac": "⌘⇧<",
    "slug": "decrease-font-size-one-step",
    "level": "Useful"
  },
  {
    "category": "Number Formatting",
    "title": "Apply general format",
    "windows": "Ctrl Shift~",
    "mac": "⌃⇧~",
    "slug": "apply-general-format",
    "level": "Useful"
  },
  {
    "category": "Number Formatting",
    "title": "Apply currency format",
    "windows": "Ctrl Shift$",
    "mac": "⌃⇧$",
    "slug": "apply-currency-format",
    "level": "Most used"
  },
  {
    "category": "Number Formatting",
    "title": "Apply percentage format",
    "windows": "Ctrl Shift%",
    "mac": "⌃⇧%",
    "slug": "apply-percentage-format",
    "level": "Most used"
  },
  {
    "category": "Number Formatting",
    "title": "Apply scientific format",
    "windows": "Ctrl Shift^",
    "mac": "⌃⇧^",
    "slug": "apply-scientific-format",
    "level": "Useful"
  },
  {
    "category": "Number Formatting",
    "title": "Apply date format",
    "windows": "Ctrl Shift#",
    "mac": "⌃⇧#",
    "slug": "apply-date-format",
    "level": "Useful"
  },
  {
    "category": "Number Formatting",
    "title": "Apply time format",
    "windows": "Ctrl Shift@",
    "mac": "⌃⇧@",
    "slug": "apply-time-format",
    "level": "Useful"
  },
  {
    "category": "Number Formatting",
    "title": "Apply number format",
    "windows": "Ctrl Shift!",
    "mac": "⌃⇧!",
    "slug": "apply-number-format",
    "level": "Useful"
  },
  {
    "category": "Borders",
    "title": "Add border outline",
    "windows": "Ctrl Shift&",
    "mac": "⌘⌥0",
    "slug": "add-border-outline",
    "level": "Specialized"
  },
  {
    "category": "Borders",
    "title": "Add or remove border right",
    "windows": "Alt R",
    "mac": "⌘⌥→",
    "slug": "add-or-remove-border-right",
    "level": "Specialized"
  },
  {
    "category": "Borders",
    "title": "Add or remove border left",
    "windows": "Alt L",
    "mac": "⌘⌥←",
    "slug": "add-or-remove-border-left",
    "level": "Specialized"
  },
  {
    "category": "Borders",
    "title": "Add or remove border top",
    "windows": "Alt T",
    "mac": "⌘⌥↑",
    "slug": "add-or-remove-border-top",
    "level": "Specialized"
  },
  {
    "category": "Borders",
    "title": "Add or remove border bottom",
    "windows": "Alt B",
    "mac": "⌘⌥↓",
    "slug": "add-or-remove-border-bottom",
    "level": "Specialized"
  },
  {
    "category": "Borders",
    "title": "Add or remove border upward diagonal",
    "windows": "Alt D",
    "mac": "",
    "slug": "add-or-remove-border-upward-diagonal",
    "level": "Specialized"
  },
  {
    "category": "Borders",
    "title": "Add or remove border horizontal interior",
    "windows": "Alt H",
    "mac": "",
    "slug": "add-or-remove-border-horizontal-interior",
    "level": "Specialized"
  },
  {
    "category": "Borders",
    "title": "Add or remove border vertical interior",
    "windows": "Alt V",
    "mac": "",
    "slug": "add-or-remove-border-vertical-interior",
    "level": "Specialized"
  },
  {
    "category": "Borders",
    "title": "Remove borders",
    "windows": "Ctrl Shift _",
    "mac": "⌘⌥_",
    "slug": "remove-borders",
    "level": "Specialized"
  },
  {
    "category": "Formulas",
    "title": "Toggle absolute and relative references",
    "windows": "F4",
    "mac": "⌘T",
    "slug": "toggle-absolute-and-relative-references",
    "level": "Most used"
  },
  {
    "category": "Formulas",
    "title": "Open the Insert Function Dialog Box",
    "windows": "Shift F3",
    "mac": "Fn⇧F3",
    "slug": "open-the-insert-function-dialog-box",
    "level": "Useful"
  },
  {
    "category": "Formulas",
    "title": "Autosum selected cells",
    "windows": "Alt=",
    "mac": "⌘⇧T",
    "slug": "autosum-selected-cells",
    "level": "Most used"
  },
  {
    "category": "Formulas",
    "title": "Toggle formulas on and off",
    "windows": "Ctrl`",
    "mac": "⌃`",
    "slug": "toggle-formulas-on-and-off",
    "level": "Most used"
  },
  {
    "category": "Formulas",
    "title": "Insert function arguments",
    "windows": "Ctrl Shift A",
    "mac": "⌃⇧A",
    "slug": "insert-function-arguments",
    "level": "Useful"
  },
  {
    "category": "Formulas",
    "title": "Enter array formula",
    "windows": "Ctrl Shift Enter",
    "mac": "⌃⇧Return",
    "slug": "enter-array-formula",
    "level": "Useful"
  },
  {
    "category": "Formulas",
    "title": "Calculate worksheets",
    "windows": "F9",
    "mac": "Fn F9",
    "slug": "calculate-worksheets",
    "level": "Useful"
  },
  {
    "category": "Formulas",
    "title": "Calculate active worksheet",
    "windows": "Shift F9",
    "mac": "Fn⇧F9",
    "slug": "calculate-active-worksheet",
    "level": "Useful"
  },
  {
    "category": "Formulas",
    "title": "Force calculate all worksheets",
    "windows": "Ctrl Alt F9",
    "mac": "",
    "slug": "force-calculate-all-worksheets",
    "level": "Useful"
  },
  {
    "category": "Formulas",
    "title": "Evaluate part of a formula",
    "windows": "F9",
    "mac": "Fn F9",
    "slug": "evaluate-part-of-a-formula",
    "level": "Useful"
  },
  {
    "category": "Formulas",
    "title": "Expand or collapse the formula bar",
    "windows": "Ctrl Shift U",
    "mac": "⌃⇧U",
    "slug": "expand-or-collapse-the-formula-bar",
    "level": "Useful"
  },
  {
    "category": "Formulas",
    "title": "Display function arguments dialog box",
    "windows": "Ctrl A",
    "mac": "⌃A",
    "slug": "display-function-arguments-dialog-box",
    "level": "Useful"
  },
  {
    "category": "Formulas",
    "title": "Open the Name Manager",
    "windows": "Ctrl F3",
    "mac": "Fn⌃F3",
    "slug": "open-the-name-manager",
    "level": "Useful"
  },
  {
    "category": "Formulas",
    "title": "Define name using row and column labels",
    "windows": "Ctrl Shift F3",
    "mac": "Fn⌃⇧F3",
    "slug": "define-name-using-row-and-column-labels",
    "level": "Useful"
  },
  {
    "category": "Formulas",
    "title": "Select name box",
    "windows": "Alt F3",
    "mac": "",
    "slug": "select-name-box",
    "level": "Useful"
  },
  {
    "category": "Formulas",
    "title": "Accept function with autocomplete",
    "windows": "Tab",
    "mac": "Tab",
    "slug": "accept-function-with-autocomplete",
    "level": "Useful"
  },
  {
    "category": "Formulas",
    "title": "Paste name into formula",
    "windows": "F3",
    "mac": "F3",
    "slug": "paste-name-into-formula",
    "level": "Useful"
  },
  {
    "category": "Grid Operations",
    "title": "Display Insert Dialog box",
    "windows": "Ctrl Shift+",
    "mac": "⌘⇧+",
    "slug": "display-insert-dialog-box",
    "level": "Useful"
  },
  {
    "category": "Grid Operations",
    "title": "Insert rows",
    "windows": "Ctrl Shift+",
    "mac": "⌘⇧+",
    "slug": "insert-rows",
    "level": "Most used"
  },
  {
    "category": "Grid Operations",
    "title": "Insert columns",
    "windows": "Ctrl Shift+",
    "mac": "⌘⇧+",
    "slug": "insert-columns",
    "level": "Most used"
  },
  {
    "category": "Grid Operations",
    "title": "Display Delete dialog box",
    "windows": "Ctrl-",
    "mac": "⌘-",
    "slug": "display-delete-dialog-box",
    "level": "Useful"
  },
  {
    "category": "Grid Operations",
    "title": "Delete rows",
    "windows": "Ctrl-",
    "mac": "⌘-",
    "slug": "delete-rows",
    "level": "Most used"
  },
  {
    "category": "Grid Operations",
    "title": "Delete columns",
    "windows": "Ctrl-",
    "mac": "⌘-",
    "slug": "delete-columns",
    "level": "Most used"
  },
  {
    "category": "Grid Operations",
    "title": "Delete cells",
    "windows": "Ctrl-",
    "mac": "⌘-",
    "slug": "delete-cells",
    "level": "Useful"
  },
  {
    "category": "Grid Operations",
    "title": "Delete contents of selected cells",
    "windows": "Delete",
    "mac": "Fn Delete",
    "slug": "delete-contents-of-selected-cells",
    "level": "Useful"
  },
  {
    "category": "Grid Operations",
    "title": "Hide columns",
    "windows": "Ctrl 0",
    "mac": "⌃0",
    "slug": "hide-columns",
    "level": "Most used"
  },
  {
    "category": "Grid Operations",
    "title": "Hide rows",
    "windows": "Ctrl 9",
    "mac": "⌃9",
    "slug": "hide-rows",
    "level": "Most used"
  },
  {
    "category": "Grid Operations",
    "title": "Unhide rows",
    "windows": "Ctrl Shift 9",
    "mac": "⌃⇧9",
    "slug": "unhide-rows",
    "level": "Useful"
  },
  {
    "category": "Grid Operations",
    "title": "Unhide columns",
    "windows": "Ctrl Shift 0",
    "mac": "⌃⇧0",
    "slug": "unhide-columns",
    "level": "Useful"
  },
  {
    "category": "Grid Operations",
    "title": "Group rows or columns",
    "windows": "Alt Shift→",
    "mac": "⌘⇧K",
    "slug": "group-rows-or-columns",
    "level": "Useful"
  },
  {
    "category": "Grid Operations",
    "title": "Ungroup rows or columns",
    "windows": "Alt Shift←",
    "mac": "⌘⇧J",
    "slug": "ungroup-rows-or-columns",
    "level": "Useful"
  },
  {
    "category": "Grid Operations",
    "title": "Open Group Dialog Box",
    "windows": "Alt Shift→",
    "mac": "⌘⇧K",
    "slug": "open-group-dialog-box",
    "level": "Useful"
  },
  {
    "category": "Grid Operations",
    "title": "Open Ungroup Dialog Box",
    "windows": "Alt Shift←",
    "mac": "⌘⇧J",
    "slug": "open-ungroup-dialog-box",
    "level": "Useful"
  },
  {
    "category": "Grid Operations",
    "title": "Hide or show outline symbols",
    "windows": "Ctrl 8",
    "mac": "⌃8",
    "slug": "hide-or-show-outline-symbols",
    "level": "Useful"
  },
  {
    "category": "Grid Operations",
    "title": "Zoom in",
    "windows": "Ctrl Alt+",
    "mac": "⌥⌘+",
    "slug": "zoom-in",
    "level": "Useful"
  },
  {
    "category": "Grid Operations",
    "title": "Zoom out",
    "windows": "Ctrl Alt-",
    "mac": "⌥⌘-",
    "slug": "zoom-out",
    "level": "Useful"
  },
  {
    "category": "Grid Operations",
    "title": "Zoom scroll",
    "windows": "Ctrl scroll",
    "mac": "^scroll",
    "slug": "zoom-scroll",
    "level": "Useful"
  },
  {
    "category": "Pivot Tables",
    "title": "Select entire pivot table",
    "windows": "Ctrl A",
    "mac": "⌘A",
    "slug": "select-entire-pivot-table",
    "level": "Specialized"
  },
  {
    "category": "Pivot Tables",
    "title": "Toggle pivot table field checkbox",
    "windows": "Space",
    "mac": "Space",
    "slug": "toggle-pivot-table-field-checkbox",
    "level": "Specialized"
  },
  {
    "category": "Pivot Tables",
    "title": "Group pivot table items",
    "windows": "Alt Shift→",
    "mac": "⌘⇧K",
    "slug": "group-pivot-table-items",
    "level": "Specialized"
  },
  {
    "category": "Pivot Tables",
    "title": "Ungroup pivot table items",
    "windows": "Alt Shift←",
    "mac": "⌘⇧J",
    "slug": "ungroup-pivot-table-items",
    "level": "Specialized"
  },
  {
    "category": "Pivot Tables",
    "title": "Hide pivot table item",
    "windows": "Ctrl-",
    "mac": "Ctrl-",
    "slug": "hide-pivot-table-item",
    "level": "Specialized"
  },
  {
    "category": "Pivot Tables",
    "title": "Create pivot chart on same worksheet",
    "windows": "Alt F1",
    "mac": "",
    "slug": "create-pivot-chart-on-same-worksheet",
    "level": "Specialized"
  },
  {
    "category": "Pivot Tables",
    "title": "Create pivot chart on new worksheet",
    "windows": "F11",
    "mac": "Fn F11",
    "slug": "create-pivot-chart-on-new-worksheet",
    "level": "Specialized"
  },
  {
    "category": "Pivot Tables",
    "title": "Open pivot table wizard",
    "windows": "Alt D P",
    "mac": "⌘⌥P",
    "slug": "open-pivot-table-wizard",
    "level": "Specialized"
  },
  {
    "category": "Workbook",
    "title": "Insert new worksheet",
    "windows": "Shift F11",
    "mac": "fn⇧F11",
    "slug": "insert-new-worksheet",
    "level": "Most used"
  },
  {
    "category": "Workbook",
    "title": "Go to next worksheet",
    "windows": "Ctrl PgDn",
    "mac": "⌥→",
    "slug": "go-to-next-worksheet",
    "level": "Most used"
  },
  {
    "category": "Workbook",
    "title": "Go to previous worksheet",
    "windows": "Ctrl PgUp",
    "mac": "⌥←",
    "slug": "go-to-previous-worksheet",
    "level": "Most used"
  },
  {
    "category": "Workbook",
    "title": "Move to next pane",
    "windows": "F6",
    "mac": "Fn F6",
    "slug": "move-to-next-pane",
    "level": "Useful"
  },
  {
    "category": "Workbook",
    "title": "Move to previous pane",
    "windows": "Shift F6",
    "mac": "Fn⇧F6",
    "slug": "move-to-previous-pane",
    "level": "Useful"
  },
  {
    "category": "Workbook",
    "title": "Go to next workbook",
    "windows": "Ctrl Tab",
    "mac": "⌘`",
    "slug": "go-to-next-workbook",
    "level": "Useful"
  },
  {
    "category": "Workbook",
    "title": "Go to previous workbook",
    "windows": "Ctrl Shift Tab",
    "mac": "⌘⇧`",
    "slug": "go-to-previous-workbook",
    "level": "Useful"
  },
  {
    "category": "Workbook",
    "title": "Minimize current workbook window",
    "windows": "Ctrl F9",
    "mac": "⌘M",
    "slug": "minimize-current-workbook-window",
    "level": "Useful"
  },
  {
    "category": "Workbook",
    "title": "Maximize current workbook window",
    "windows": "Ctrl F10",
    "mac": "fn⌃F10",
    "slug": "maximize-current-workbook-window",
    "level": "Useful"
  },
  {
    "category": "Workbook",
    "title": "Select adjacent worksheets",
    "windows": "Shift Click",
    "mac": "⇧Click",
    "slug": "select-adjacent-worksheets",
    "level": "Useful"
  },
  {
    "category": "Workbook",
    "title": "Select non-adjacent worksheets",
    "windows": "Ctrl Click",
    "mac": "⌘Click",
    "slug": "select-non-adjacent-worksheets",
    "level": "Useful"
  },
  {
    "category": "Workbook",
    "title": "Toggle scroll lock",
    "windows": "ScrLk",
    "mac": "Fn⇧F14",
    "slug": "toggle-scroll-lock",
    "level": "Useful"
  },
  {
    "category": "Workbook",
    "title": "Toggle full screen",
    "windows": "Ctrl Shift F1",
    "mac": "⌃⌘F",
    "slug": "toggle-full-screen",
    "level": "Useful"
  },
  {
    "category": "Dialog Boxes",
    "title": "Move to next control",
    "windows": "Tab",
    "mac": "Tab",
    "slug": "move-to-next-control",
    "level": "Specialized"
  },
  {
    "category": "Dialog Boxes",
    "title": "Move to previous control",
    "windows": "Shift Tab",
    "mac": "⇧Tab",
    "slug": "move-to-previous-control",
    "level": "Specialized"
  },
  {
    "category": "Dialog Boxes",
    "title": "Move to next tab",
    "windows": "Ctrl Tab",
    "mac": "⌃Tab",
    "slug": "move-to-next-tab",
    "level": "Specialized"
  },
  {
    "category": "Dialog Boxes",
    "title": "Move to previous tab",
    "windows": "Ctrl Shift Tab",
    "mac": "⌃⇧Tab",
    "slug": "move-to-previous-tab",
    "level": "Specialized"
  },
  {
    "category": "Dialog Boxes",
    "title": "Accept and apply",
    "windows": "Enter",
    "mac": "Return",
    "slug": "accept-and-apply",
    "level": "Specialized"
  },
  {
    "category": "Dialog Boxes",
    "title": "Check and uncheck box",
    "windows": "Space",
    "mac": "Space",
    "slug": "check-and-uncheck-box",
    "level": "Specialized"
  },
  {
    "category": "Dialog Boxes",
    "title": "Cancel and close the dialog box",
    "windows": "Esc",
    "mac": "Esc",
    "slug": "cancel-and-close-the-dialog-box",
    "level": "Specialized"
  },
  {
    "category": "Other",
    "title": "Check spelling",
    "windows": "F7",
    "mac": "Fn F7",
    "slug": "check-spelling",
    "level": "Most used"
  },
  {
    "category": "Other",
    "title": "Open Thesaurus dialog box",
    "windows": "Shift F7",
    "mac": "Fn⇧F7",
    "slug": "open-thesaurus-dialog-box",
    "level": "Useful"
  },
  {
    "category": "Other",
    "title": "Open Macro dialog box",
    "windows": "Alt F8",
    "mac": "Fn⌥F8",
    "slug": "open-macro-dialog-box",
    "level": "Useful"
  },
  {
    "category": "Other",
    "title": "Open Power Query Editor",
    "windows": "Alt F12",
    "mac": "Fn⌥F12",
    "slug": "open-power-query-editor",
    "level": "Most used"
  },
  {
    "category": "Other",
    "title": "Open VBA Editor",
    "windows": "Alt F11",
    "mac": "Fn⌥F11",
    "slug": "open-vba-editor",
    "level": "Most used"
  },
  {
    "category": "Other",
    "title": "Duplicate object",
    "windows": "Ctrl D",
    "mac": "⌘D",
    "slug": "duplicate-object",
    "level": "Useful"
  },
  {
    "category": "Other",
    "title": "Snap to grid",
    "windows": "Alt",
    "mac": "⌘",
    "slug": "snap-to-grid",
    "level": "Useful"
  },
  {
    "category": "Other",
    "title": "Hide or show objects",
    "windows": "Ctrl 6",
    "mac": "⌃6",
    "slug": "hide-or-show-objects",
    "level": "Useful"
  },
  {
    "category": "Other",
    "title": "Display Modify Cell Style dialog box",
    "windows": "Alt'",
    "mac": "⌘⇧L",
    "slug": "display-modify-cell-style-dialog-box",
    "level": "Useful"
  },
  {
    "category": "Other",
    "title": "Display right-click menu",
    "windows": "Shift F10",
    "mac": "Fn⇧F10",
    "slug": "display-right-click-menu",
    "level": "Useful"
  },
  {
    "category": "Other",
    "title": "Insert or edit note",
    "windows": "Shift F2",
    "mac": "Fn⇧F2",
    "slug": "insert-or-edit-note",
    "level": "Useful"
  },
  {
    "category": "Other",
    "title": "Insert threaded comment",
    "windows": "Ctrl Shift F2",
    "mac": "Fn⌘⇧F2",
    "slug": "insert-threaded-comment",
    "level": "Useful"
  },
  {
    "category": "Other",
    "title": "Delete comment",
    "windows": "Shift F10 D",
    "mac": "fn⇧F10",
    "slug": "delete-comment",
    "level": "Useful"
  },
  {
    "category": "Other",
    "title": "Display control menu",
    "windows": "Alt Space",
    "mac": "",
    "slug": "display-control-menu",
    "level": "Useful"
  }
];
